import { useActiveOrganization } from "@/context/ActiveOrganizationProvider";
import { InlineMenu } from "@components/SimpleTable/InlineMenu";
import { ContextMenu } from "@components/library/ContextMenu";
import { ArrowUpRightIcon } from "@components/library/Icons";
import { EvaluatorLog } from "@/types/app/log";
import { ArrowCounterClockwise, Play } from "@phosphor-icons/react";
import { ConditionalTooltip } from "@components/library/Tooltip";
import { Evaluator } from "@/types/app/evaluator";
import { getFileHref } from "@/lib/path-utils";

interface Props {
  evaluator: Evaluator;
  evaluatorLog: EvaluatorLog | null;
  handleRun: () => void;
}

export const EvaluationDetailsActions = ({ evaluator, evaluatorLog: evaluatorLog, handleRun }: Props) => {
  const { slug } = useActiveOrganization();

  const isHumanEvaluator = evaluator.spec.evaluator_type === "human";
  const isExternalEvaluator = evaluator.spec.evaluator_type === "external";

  return (
    <div className="flex items-center gap-6">
      <InlineMenu>
        <ContextMenu.Item
          href={
            evaluatorLog ? `${getFileHref({ slug, id: evaluator.id, page: "logs" })}?id=${evaluatorLog.id}` : undefined
          }
          key="logs"
          disabled={!evaluatorLog}
          withinDropdownMenu
          IconLeft={ArrowUpRightIcon}
          target="_blank"
        >
          View Log
        </ContextMenu.Item>
        <ConditionalTooltip
          condition={isHumanEvaluator || isExternalEvaluator}
          content={`Cannot re-run logs from ${isHumanEvaluator ? "human" : "external"} evaluators.`}
        >
          <ContextMenu.Item
            disabled={isHumanEvaluator || isExternalEvaluator}
            key="rerun"
            withinDropdownMenu
            onClick={handleRun}
            IconLeft={{ Icon: evaluatorLog ? ArrowCounterClockwise : Play }}
          >
            {evaluatorLog ? "Re-run" : "Run"}
          </ContextMenu.Item>
        </ConditionalTooltip>
      </InlineMenu>
    </div>
  );
};
